import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'
import stat from '@/plugins/stat'
import Http from '@/plugins/http'
import InfiniteScroll from 'vue-infinite-scroll'
import VueLazyLoad from 'vue-lazyload'
import LazyElementUiComponent from '@/plugins/lazy-element'
import VeeValidate, {
  Validator
} from 'vee-validate/dist/vee-validate.minimal.esm'
import zhCN from 'vee-validate/dist/locale/zh_CN'
import loadingImg from '@/assets/img/loading.png'
import '@/components/base/index'
import '@/utils/filters'
import '@/assets/styles/global.scss'

Vue.config.productionTip = false

Vue.use(LazyElementUiComponent)

Vue.use(stat)

Vue.use(VueLazyLoad, {
  loading: loadingImg,
  error: loadingImg
})

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

Vue.use(VeeValidate, {
  errorBagName: 'errorBag',
  fieldsBagName: 'fieldBag'
})
Vue.use(Http)

Vue.use(InfiniteScroll)

Validator.localize('zh_CN', zhCN)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
